@if (!useSummaryView) {
  @if (!field.hidden) {
    <div class="flex flex-col w-full" animate.enter="fade-in">
        <div class="flex flex-row items-center w-full mb-4" [ngClass]="{
            'justify-left': field.browserOpts.alignment === 'LEFT',
            'justify-center': field.browserOpts.alignment === 'CENTER',
            'justify-right': field.browserOpts.alignment === 'RIGHT'
        }">
        @if (field.browserOpts.inLineWithCaption) {
          <div class="mr-2">
            <div class="leading-6 font-medium">{{ field.label | localize }}</div>
            @if (field.hint) {
              <div class="text-md text-secondary">{{ field.hint | localize }}</div>
            }
          </div>
        }
        <div>
          @if (!field.browserOpts.inLineWithCaption) {
            <div class="mb-4">
              <div class="leading-6 font-medium">{{ field.label | localize }}</div>
              @if (field.hint) {
                <div class="text-md text-secondary">{{ field.hint | localize }}</div>
              }
            </div>
          }
          <mat-radio-group [formControl]="field.control">
            <mat-radio-button class="mr-4" [value]="true">
              {{ field.trueLabel ? (field.trueLabel | localize) : ('yes' | transloco) }}
            </mat-radio-button>
            <mat-radio-button [value]="false">
              {{ field.falseLabel ? (field.falseLabel | localize) : ('no' | transloco) }}
            </mat-radio-button>
          </mat-radio-group>
          @if (!field.readonly &&
            field.control.touched &&
            field.control.errors) {
            @if (field.control.hasError('invalidValue')) {
              <div
                class="text-sm text-warn leading-none font-medium mt-2">
                {{ 'errorRadioInvalidValue' | transloco:{ requiredValue:
                field.control.errors.invalidValue.required ?
                field.trueLabel ? (field.trueLabel | localize) : ('yes' | transloco) :
                field.falseLabel ? (field.falseLabel | localize) : ('no' | transloco) } }}
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
} @else {
  {{ (field.control.value === undefined ? field.emptyLabel : (field.control.value ? field.trueLabel :
  field.falseLabel)) | localize }}
}

